var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelShadow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.502 348.351C310.116 348.351 332.502 325.91 332.502 298.228C332.502 270.546 310.116 248.105 282.502 248.105C254.888 248.105 232.502 270.546 232.502 298.228C232.502 325.91 254.888 348.351 282.502 348.351Z",
    fill: "#642D79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.5 338.325C304.591 338.325 322.5 320.373 322.5 298.227C322.5 276.081 304.591 258.129 282.5 258.129C260.409 258.129 242.5 276.081 242.5 298.227C242.5 320.373 260.409 338.325 282.5 338.325Z",
    fill: "#813B9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M273.693 286.046L253.943 288.953L268.243 302.887L264.843 322.536L282.493 313.263L300.143 322.536L296.743 302.887L311.043 288.953L291.293 286.046L282.493 268.152L273.693 286.046Z",
    fill: "#F0E579"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M232.3 295.725C232.439 309.065 237.859 321.803 247.367 331.137C256.875 340.472 269.693 345.637 283 345.497C296.307 345.358 309.014 339.925 318.325 330.393C327.637 320.862 332.789 308.013 332.65 294.673C332.566 286.41 330.526 278.284 326.7 270.965C331.791 279.358 334.553 288.961 334.7 298.783C334.769 305.655 333.487 312.473 330.927 318.848C328.368 325.223 324.581 331.031 319.782 335.939C310.091 345.851 296.869 351.498 283.025 351.637C269.181 351.777 255.848 346.398 245.96 336.683C236.072 326.968 230.439 313.714 230.3 299.836C230.193 290.022 232.77 280.367 237.75 271.917C234.067 279.305 232.198 287.467 232.3 295.725Z",
    fill: "#8C8C8C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelShadow);
export default __webpack_public_path__ + "static/media/wheelShadow.0eb620bb1c0be86077163b26ef2e140e.svg";
export { ForwardRef as ReactComponent };